import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
import Icon from '../../Icon';

const StyledComponent = styled<any, any>(Icon, 'modalCloseIcon', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    height: '16px',
    width: '16px',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalCloseIcon.tsx